import { useEffect } from "react";
import { useState } from "react";
import { CgChevronLeftO } from "react-icons/cg";
import { FaMapSigns } from "react-icons/fa";
import { HashLoader } from "react-spinners";

import { COLORS } from "../../utils/colors";
import { getCustomerByRef } from "../../api/user";

export const CustomerProfile = ({
  refference,
  setCustomerProfile,
  eventID,
}) => {
  const [user, setUser] = useState(null);
  const [transactions, setTransactions] = useState(null);

  useEffect(async () => {
    const res = await getCustomerByRef(refference);
    setUser(res.data.user);
    setTransactions(res.data.user.transactions[eventID]);
  }, []);

  const goBack = () => {
    setCustomerProfile(false);
  };
  return (
    <div className="customer-profile-container">
      <div className="customer-header">
        <div className="ticket-header">
          <div className="ticket-navbar">
            <div className="back-button" onClick={() => goBack()}>
              <CgChevronLeftO size={25} />
              <p>Back</p>
            </div>
          </div>
          <h1>{`Profile - ${user?.email}`}</h1>
        </div>
      </div>
      {!user ? (
        <HashLoader
          size={20}
          color={COLORS.black}
          style={{ margin: "50px 0px 10px", alignSelf: "center" }}
        />
      ) : (
        <div>
          <div className="details-table">
            <div className="detail-row">
              <h5>Email</h5>
              <p>{user.email || "empty"}</p>
            </div>
            <div className="detail-row">
              <h5>First Name</h5>
              <p>{user.firstName || "empty"}</p>
            </div>
            <div className="detail-row">
              <h5>Last Name</h5>
              <p>{user.lastName || "empty"}</p>
            </div>
            <div className="detail-row">
              <h5>Phone</h5>
              <p>{user.phone || "empty"}</p>
            </div>
            <div className="detail-row">
              <h5>Ocupation</h5>
              <p>{user.ocupation || "empty"}</p>
            </div>
            <div className="detail-row">
              <h5>Company</h5>
              <p>{user.company || "empty"}</p>
            </div>
          </div>
          <div className="customer-transactions">
            <h2 className="subTitle">
              <FaMapSigns /> Transaction History
            </h2>
            <div className="transactions-wrapper">
              {transactions?.map((item, index) => {
                return (
                  <p key={index}>
                    {index + 1} · {item}
                  </p>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
